import { forwardRef, useEffect } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import {
  JMonthlyTargetActions,
  resetForm,
  setDialog,
} from "../../../../app/slices/jomla/monthlyTargetSlice";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { SelectJItem } from "../../../../components/Selectors/jomla/SelectJItem";
import { SelectRepresentative } from "../../../../components/Selectors/SelectRepresentative";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const JMonthlyTargetForm = () => {
  const dispatch = useDispatch();

  const _JMonthlyTarget = useSelector(
    (state) => state.jMonthlyTarget.jMonthlyTarget
  );
  const _SearchBody = useSelector((state) => state.jMonthlyTarget.searchBody);
  const _JItem = useSelector((state) => state.JItems.JItemsList.data);
  const users = useSelector((state) => state.user.usersList.data);

  const isAdd = _JMonthlyTarget.form.id ? false : true;
  const { control, reset, handleSubmit, setValue } = useForm({
    defaultValues: _JMonthlyTarget.form,
  });

  const onSubmit = (data) => {
    if (isAdd) {
      dispatch(
        JMonthlyTargetActions.create(
          {
            year: dayjs(data.date).year(),
            month: dayjs(data.date).month() + 1,
            j_item_id: data.j_item_id,
            user_id: data.user_id,
            target: data.target,
          },
          _SearchBody
        )
      );
    } else {
      dispatch(
        JMonthlyTargetActions.update(
          data.id,
          {
            year: dayjs(data.date).year(),
            month: dayjs(data.date).month() + 1,
            j_item_id: data.j_item_id,
            user_id: data.user_id,
            target: data.target,
          },
          _SearchBody
        )
      );
    }
  };
  useEffect(() => {
    reset({ ..._JMonthlyTarget.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_JMonthlyTarget.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDialog = () => {
    dispatch(setDialog());
  };

  return (
    // <Typography>form test</Typography>
    <Dialog
      open={_JMonthlyTarget.dialog}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      dir="rtl"
      onClose={() => {
        handleDialog();
      }}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent>
        <Typography
          mb={3}
          variant="h4"
          color={"purple"}
          gutterBottom
          component="div"
        >
          {isAdd ? "أضافة " : "تعديل"}
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Controller
                name="date"
                control={control}
                render={({ field }) => (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      inputFormat="YYYY-MM"
                      label={'"شهر" and "سنة"'}
                      views={["month", "year"]}
                      value={field.value}
                      onChange={(e) => {
                        setValue("date", e);
                      }}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          fullWidth
                          {...params}
                          inputProps={{
                            ...params.inputProps,
                            placeholder: "شهر/سنة",
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Controller
                control={control}
                name={`j_item_id`}
                render={({ field }) => (
                  <SelectJItem
                    {...field}
                    required
                    onChange={(e, newValue) => {
                      setValue(`j_item_id`, newValue ? newValue.id : null);
                    }}
                    value={
                      _JItem.filter((x) => x.id === field.value)[0] ?? null
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Controller
                name="target"
                control={control}
                render={({ field }) => (
                  <TextField
                    required
                    size="small"
                    label="الهدف الشهري"
                    fullWidth
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Grid item xs={12} md={12}>
                <Controller
                  name="user_id"
                  control={control}
                  render={({ field }) => (
                    <SelectRepresentative
                      onChange={(e, newValue) => {
                        setValue("user_id", newValue ? newValue.id : null);
                      }}
                      value={
                        users.filter((user) => user.id === field.value)[0] ??
                        null
                      }
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} md={12}>
              <Button type="submit" variant="contained" color="primary">
                حفظ
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default JMonthlyTargetForm;
